
  document.querySelectorAll('.toggle-button').forEach(button => {
    button.addEventListener('click', () => {
      const article = button.closest('.container-article');
      const contents = article.querySelectorAll('.content-hide');
      const label = button.querySelector('.label-click');
      const icon = button.querySelector('.arrow-icon');

      let isAnyExpanded = false;

      contents.forEach(content => {
        content.classList.toggle('show');
        if (content.classList.contains('show')) {
          isAnyExpanded = true;
        }
      });

      label.textContent = isAnyExpanded ? 'Collapse' : 'Expand';
      icon.classList.toggle('arrow-up', isAnyExpanded);
    });
  });

document.addEventListener("DOMContentLoaded", () => {
  // Loop over all swiper containers
  document.querySelectorAll(".swiper").forEach((swiperContainer, index) => {
    const wrapper = swiperContainer.querySelector(".swiper-wrapper");
    const slides = Array.from(wrapper.children);
    const paginationEl = swiperContainer.querySelector(".swiper-pagination");

    let swiperInstance;

    function initSwiper() {
      if (swiperInstance) swiperInstance.destroy(true, true);

      swiperInstance = new Swiper(swiperContainer, {
        loop: false,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    }

    function filterSlides(color) {
      wrapper.innerHTML = "";

      const filtered = slides.filter((slide) => {
        const img = slide.querySelector("img");
        return img && img.alt === color;
      });

      filtered.forEach((slide) => {
        wrapper.appendChild(slide.cloneNode(true));
      });

      initSwiper();
    }

    // Set initial filter based on first slide
    const firstColor = slides[0]?.querySelector("img")?.alt || null;
    if (firstColor) filterSlides(firstColor);

    // Attach events to local swatches only
    swiperContainer
      .closest(".product-section")
      .querySelectorAll(".color_swatch")
      .forEach((swatch) => {
        swatch.addEventListener("click", () => {
          const color = swatch.getAttribute("data-color");
          filterSlides(color);
        });
      });
  });
});
const labels = [
  "PROTECTION",
  "ORGANIZATION",
  "DURABILITY",
  "PORTABILITY",
  "VERSATILITY",
  "CAPACITY",
];

const allRatingsGrids = document.querySelectorAll(".ratings-grid");

if (allRatingsGrids.length) {
  allRatingsGrids.forEach((ratingsGrid) => {
    const ratingValues = ratingsGrid
      .getAttribute("data-rating-value")
      .split(",")
      .map((val) => parseFloat(val.trim()));

    const maxRating = 5;

    ratingValues.forEach((value, index) => {
      const container = document.createElement("div");
      container.className = "rating-item";

      const label = document.createElement("div");
      label.className = "rating-label";
      label.innerHTML = `<span>${labels[index]}</span><span>${value}/5</span>`;
      container.appendChild(label);

      const bar = document.createElement("div");
      bar.className = "rating-bar";

      for (let i = 1; i <= maxRating; i++) {
        const segment = document.createElement("div");
        segment.classList.add("bar-segment");

        if (i <= Math.floor(value)) {
          segment.classList.add("bar-filled");
        } else if (i - value < 1) {
          segment.classList.add("bar-filled");
          segment.style.background = `linear-gradient(to right, #55aa00 ${
            (value % 1) * 100
          }%, #e2e9db ${(value % 1) * 100}%)`;
        }

        bar.appendChild(segment);
      }

      container.appendChild(bar);
      ratingsGrid.appendChild(container);
    });
  });
}
